//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'
export default {
    name: "topicHot",
    data(){
        return {
            scroll:"",
            wrapperChildLenght:'',
        }
    },
    props: {
        comment: {
            type: Array,
            // default: []
            default() { return []}
        },
    },

    mounted(){
        this.scrollInit()
    },
    methods:{
        // 热门滚动
        scrollInit(){
            let personWidth = 0,wrapperChild = this.$refs.wrapperChild;
            this.wrapperChildLenght =  wrapperChild.children.length-1;
            if(wrapperChild.children.length>1){
                this.scroll  = new BScroll(this.$refs.wrapper, {
                    startX: 0,
                    click: true,
                    scrollX: true,
                    scrollY: false,
                    eventPassthrough: "vertical"
                });
                for (let i = 0; i < wrapperChild.children.length; i++) {
                    personWidth += wrapperChild.children[i].clientWidth 
                }
                personWidth += (wrapperChild.children.length-1) * 15 +10
            }else{
               personWidth =  250;
            }
            this.$refs.wrapperChild.style.width = personWidth+ "px";
        }
    }
}
